// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper-jAAUO"};